<template>
  <div class="tableDetail" :style="{
    width: isMobile ? '375px' : tableDetailData.showWay === 3 ? '100%' : '',
    margin: isMobile ? '0 auto' : ''
    }">
    <!-- 表格（经典布局） -->
    <template v-if="!tableDetailData.showWay || tableDetailData.showWay === 1">
      <template v-if="tableDetailData.titleForRow === 'open'">
        <customRow ref="customRow" :tableDetailData="tableDetailData" :tableRef="$refs.table" :tabelIndexRef="$refs.tabelIndexRef" :tableColRef="$refs.tableColRef" :tableWidth="tableWidth" :todoWidth="parseInt(getWidths(tableDetailData.relevance || []))" />
      </template>
      <el-table
        :data="tableDetailData.fromdatas || []"
        :height="tableCustomHeight"
        border
        :stripe="true"
        :header-cell-style="{
          background: '#f8f9fb',
          color: '#333',
          fontWeight: 'normal'
        }"
        :row-class-name="getRowClass"
        :show-overflow-tooltip="true"
        style="width: 100%"
        ref="table"
        :key="tableKey"
        :class="[isCustomExcel ? 'custom-table-title' : '']"
        v-infinite-scroll="load"
        :header-row-class-name="hideSecondLevelHeader"
        @cell-click="columnClick"
        @header-dragend="headerDragend"
        highlight-current-row
        @selection-change="handleCurrentChange"
        @select="handleSelectChange"
      >
        <template #empty>
          <div class="empty">
            <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          v-if="tableDetailData.isChecked"
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          :width="getXhWidth()"
          :min-width="getXhWidth()"
          :fixed="isNumFixed"
          v-if="tableDetailData.reCheck"
        >
          <template v-slot:header>
            <div :style="getAlign(tableDetailData.titleConfig)">
              <div class="ellipsis" :style="getFont(tableDetailData.titleConfig)">序号</div>
            </div>
          </template>
          <template v-slot="scope">
            <div :style="getAlign(tableDetailData.valueConfig)" :data-index="scope.$index" class="zdysy">
              <div class="ellipsis" :style="getFont(tableDetailData.valueConfig)">
                {{indexMethod(scope.$index)}}
              </div>
            </div>
          </template>
        </el-table-column>
        <template v-for="(item, i) in selectDatas" :key="i">
          <tableDetailCol
            :index="i"
            :order="i"
            :prop="formNameChange(tableDetailData.isSource != 11 ? item.revisabilityName : item.key)"
            :label="item.revisabilityName"
            show-overflow-tooltip
            :min-width="getWidth(item)"
            :tableDetailData="tableDetailData"
            :column="item"
            :fixed="item.fixed"
            :activeCol="curRow"
            :todoListConfig="todoListConfig"
            @handleEdit="handleDetailCol"
            @reload-page="$emit('reload-page')"
            @openUserDialog="openRelationUserDialog"
            @clearActiveCol="clearActiveCol"
            v-if="!item.isHide"
            :width="!tableDetailData.tableModel || tableDetailData.tableModel === 'default' ? getWidth(item) : ''"
          >
            <template  v-slot:header="scope">
              <div class="detail-header" :style="getAlign(tableDetailData.titleConfig)" style="position: relative;">
                <div class="ellipsis" :style="[getFont(tableDetailData.titleConfig)]">{{item.revisabilityName}}</div>
                <orderAndScreen @goSearch="goSearch(item, $event)" :info="item" />
                <i v-if="getIcon(scope)" class="iconfont icon-you header-mom" :style="lineClampMom[item.title] ? 'transform:rotate(90deg)scale(0.7)translateY(-50%)' : 'transform:rotate(0deg)scale(0.7)translateY(0)'" @click="clampMom(item.title)" />
                <!-- <i v-if="getIconRight(!tableDetailData.tableModel || tableDetailData.tableModel === 'default' ? getWidth(item) : '', item)" class="iconfont icon-you header-mom" :style="lineClampMom[item.title] ? 'transform:rotate(90deg)scale(0.7)translateY(-50%)' : 'transform:rotate(0deg)scale(0.7)translateY(0)'" @click="clampMom(item.title)" /> -->
              </div>
            </template>
            <template v-slot="scope">
              <div @dblclick="goTodoEdit({ e: $event, scope: scope, column: item })">
                <!-- 文件，图片 -->
                <template v-if="curRow.approvingId === scope.$index && item.name === curRow.name && item.title === curRow.title">
                  <todoEdit @change="todoChange" :appendToBody="Boolean(tableDetailData.isTodoDiagle)" @reset="todoReset" :approvalId="getApprovalId" ref="todoEditRef" />
                </template>
                <template v-else>
                  <div
                    class="detail"
                    v-if="item.type === 'file' || item.type === 'image'"
                  >
                    <div
                      class="detailItem"
                      v-for="(item2, index2) in scope.row[scope.column.property]"
                      :key="index2"
                    >
                      <!-- {{ showScope(scope) }} -->
                      <div class="name" @click="preview(item2)" :style="getFont(tableDetailData.valueConfig)">
                        <i class="iconfont icon-tianjiafujian"></i>
                        <span>{{ fileNameShow(item2.response) }}</span>
                      </div>
                      <div
                        class="upload"
                        @click="upload(item2)"
                        v-if="item.type === 'file'"
                      >
                        <i class="iconfont icon-xiazai2x"></i>
                      </div>
                    </div>
                  </div>
                  <!-- 非文件，图片 -->
                  <!-- 多选 -->
                  <!-- <div :style="[getAlign(tableDetailData.valueConfig), {'-webkit-line-clamp': lineClampMom[item.title] ? 'inherit' : tableDetailData.lineClamp || 1, textAlign: tableDetailData.valueConfig && tableDetailData.valueConfig.textAlign ? tableDetailData.valueConfig.textAlign : 'left'}]" v-else-if="item.type === 'checkbox' && item.isColor" class="customization-clamp zdysy" :data-index="scope.$index"> -->
                  <div :style="[getAlign(tableDetailData.valueConfig), {'-webkit-line-clamp': lineClampMom[item.title] ? 'inherit' : tableDetailData.lineClamp || 1, display:'flex', justifyContent: justifyObj[tableDetailData.valueConfig && tableDetailData.valueConfig.textAlign ? tableDetailData.valueConfig.textAlign : 'left']}]" v-else-if="item.type === 'checkbox' && item.isColor" class="customization-clamp zdysy" :data-index="scope.$index">
                    <div v-for="(its, itsidx) in getCheckboxList(scope.row, item)" :key="itsidx" :style="[getFont(tableDetailData.valueConfig), getColorNoe(item, its)]">{{its}}</div>
                  </div>
                  <!-- <div v-else-if="item.isColor" :data-index="scope.$index" class="zdysy" :style="{textAlign: tableDetailData.valueConfig && tableDetailData.valueConfig.textAlign ? tableDetailData.valueConfig.textAlign : 'left'}"> -->
                  <div v-else-if="item.isColor" :data-index="scope.$index" class="zdysy" :style="{display:'flex', justifyContent: justifyObj[tableDetailData.valueConfig && tableDetailData.valueConfig.textAlign ? tableDetailData.valueConfig.textAlign : 'left']}">
                    <div v-if="scopeNameFun(scope, '', item.configNumber) || scopeNameFun(scope, '', item.configNumber)=== 0" :style="[getFont(tableDetailData.valueConfig), getColor(item, scope), {'-webkit-line-clamp': lineClampMom[item.title] ? 'inherit' : tableDetailData.lineClamp || 1, textAlign: tableDetailData.valueConfig && tableDetailData.valueConfig.textAlign ? tableDetailData.valueConfig.textAlign : 'left'}, JSON.stringify(getColor(item, scope)) === '{}' ? numFormat({config:item.configNumber, key:'color', numVal: scopeNameFun(scope, '', item.configNumber), isFormatNum: item.isFormatNum}) : '']" class="customization-clamp">
                      {{numFormat({config:item.configNumber, key:'left', isFormatNum: item.isFormatNum})}}{{scopeNameFun(scope, item.isFormatNum && item.configNumber && item.configNumber.separator, item.configNumber)}}{{numFormat({config:item.configNumber, key:'right', isFormatNum: item.isFormatNum})}}
                    </div>
                  </div>
                  <div v-else :data-index="scope.$index" :style="[getFont(tableDetailData.valueConfig), numFormat({config:item.configNumber, key:'color', numVal: scopeNameFun(scope, '', item.configNumber), isFormatNum: item.isFormatNum}), numFormat({config:item.configNumber, key:'color', numVal: scopeNameFun(scope, item.isFormatNum && item.configNumber && item.configNumber.separator, item.configNumber), isFormatNum: item.isFormatNum}),{'-webkit-line-clamp': lineClampMom[item.title] ? 'inherit' : tableDetailData.lineClamp || 1, display:'flex', justifyContent: justifyObj[tableDetailData.valueConfig && tableDetailData.valueConfig.textAlign ? tableDetailData.valueConfig.textAlign : 'left']}, scope.row[scope.column.property] === '' ? {color:'#99A3AD'} : '']" class="customization-clamp zdysy">
                    <!-- 预约格式 -->
                    <template v-if="item.type === 'displaylist' && scopeNameFun(scope, '', item.configNumber)">
                      <template v-if="typeof scope.row[scope.column.property] === 'string'">
                        {{scope.row[scope.column.property]}}
                      </template>
                      <template v-else v-for="(its, itsind) in scopeNameFun(scope, '', item.configNumber)">
                        {{its.date}}&nbsp;[{{its.tick && its.tick === 10 ? timeDisplaylist10 [its.time[0]] : timeDisplaylist[its.time[0]]}}-{{its.tick && its.tick === 10 ? timeDisplaylist10 [its.time[1]] : timeDisplaylist[its.time[1] + 1]}}]{{itsind < scopeNameFun(scope, '', item.configNumber).length - 1 ? ',' : ''}}
                      </template>
                    </template>
                    <template v-else-if="item.type === 'dates' && scopeNameFun(scope, '', item.configNumber)">
                      {{scopeNameFun(scope, '', item.configNumber).split(',').join('/')}}
                    </template>
                    <template v-else>
                      {{numFormat({config: item.configNumber, key: 'left', isFormatNum: item.isFormatNum})}}{{ scopeNameFun(scope, item.isFormatNum && item.configNumber && item.configNumber.separator, item.configNumber) }}{{numFormat({config: item.configNumber, key: 'right', isFormatNum: item.isFormatNum})}}
                    </template>
                  </div>
                </template>
              </div>
            </template>
          </tableDetailCol>
        </template>
        <template v-if="tableDetailData.type === 'detailed' && tableDetailData.isRelevance !== 'close' && tableDetailData.relevance && tableDetailData.relevance.length > 0">
          <el-table-column label="操作"
                           v-if="tableHeaderWidth > tableWidth && tableDetailData.tableModel !== 'fixed'"
                           class-name="cz-button"
                           fixed="right"
                           align="center"
                           :width="getWidths(tableDetailData.relevance)"
          >
            <template #header>
              <div :style="[getAlign(tableDetailData.titleConfig, true), {width:'100%'}]">
                <div class="ellipsis" :style="getFont(tableDetailData.titleConfig, true)">操作</div>
              </div>
            </template>
            <template v-slot="scope">
              <template v-for="(list, index) in tableDetailData.relevance">
                <div :class="['table-button ellipsis', getButton(list)]"
                      :key="index"
                     :style="getButtonStyle(list)"
                     v-if="isAppenBtn(list,scope.row)"
                     @click.stop="operate(scope, list)">
                  <img v-if="list.styleConfig && list.styleConfig.icon && list.styleConfig.style !== 'default'"
                       :src="'https://bigdata.topeti.com/PCRepository/middleground/home/icon/' + list.styleConfig.icon" class="table-icon" />
                  <template v-if="!list.styleConfig || list.styleConfig && list.styleConfig.style !== 'icon'">
                    {{list.styleConfig && list.styleConfig.name ? list.styleConfig.name : (list.appName || list.url)}}
                  </template>
                </div>
              </template>
              <!-- 更多 -->
              <!-- <el-dropdown v-if="tableDetailData.relevance && tableDetailData.relevance.length > 2"
                           trigger="click"
                           @command="(val) => handleCommand({scope: scope, list: val})"
                           placement="bottom">
                <i class="iconfont icon-xiangqing icon-mom"  />
                <el-dropdown-menu slot="dropdown" class="new-drop">
                  <template v-for="(list, index) in tableDetailData.relevance">
                    <el-dropdown-item v-if="index > 1"
                      :key="index + 's'"
                      :command="list">
                      {{list.styleConfig && list.styleConfig.name ? list.styleConfig.name : (list.appName || list.url)}}
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown> -->
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           v-else
                           class-name="cz-button"
                           align="center"
                           :width="getWidths(tableDetailData.relevance)"
          >
            <template #header>
              <div :style="[getAlign(tableDetailData.titleConfig, true), {width:'100%'}]">
                <div class="ellipsis" :style="getFont(tableDetailData.titleConfig, true)">操作</div>
              </div>
            </template>
            <template v-slot="scope">
              <template v-for="(list, index) in tableDetailData.relevance">
                <div :key="index" :class="['table-button ellipsis', getButton(list)]"
                     :style="getButtonStyle(list)"
                     v-if="isAppenBtn(list,scope.row)"
                     @click.stop="operate(scope, list)">
                  <img v-if="list.styleConfig && list.styleConfig.icon && list.styleConfig.style !== 'default'"
                       :src="'https://bigdata.topeti.com/PCRepository/middleground/home/icon/' + list.styleConfig.icon" class="table-icon" />
                  <template v-if="!list.styleConfig || list.styleConfig && list.styleConfig.style !== 'icon'">
                    {{list.styleConfig && list.styleConfig.name ? list.styleConfig.name : (list.appName || list.url)}}
                  </template>
                </div>
              </template>
              <!-- 更多 -->
              <!-- <el-dropdown v-if="tableDetailData.relevance && tableDetailData.relevance.length > 2"
                           trigger="click"
                           @command="(val) => handleCommand({scope: scope, list: val})"
                           placement="bottom">
                <i class="iconfont icon-xiangqing icon-mom"  />
                <el-dropdown-menu slot="dropdown" class="new-drop">
                  <template v-for="(list, index) in tableDetailData.relevance">
                    <el-dropdown-item v-if="index > 1"
                      :key="index + 's'"
                      :command="list">
                      {{list.styleConfig && list.styleConfig.name ? list.styleConfig.name : (list.appName || list.url)}}
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown> -->
            </template>
          </el-table-column>
        </template>
      </el-table>
    </template>
    <!-- 表格（竖行布局） -->
    <el-scrollbar v-else-if="tableDetailData.showWay === 2" style="height: 100%;">
      <div :class="isMobile ? 'columnArea' : 'tabStyleArea'">
        <div
          :class="isMobile ? 'columnGroup' : 'styleGroup'"
          v-for="(item, index) in tableDetailData.fromdatas"
          :key="index"
          @click="handleCurrentChange(item, index)"
          :style="index === selectedKey ? 'border:1px solid #38A2FB;' : ''"
        >
          <div
            :class="isMobile ? 'columnItem' : 'styleItem'"
            v-for="(item2, index2) in tableDetailData.selectDatas"
            :key="index2"
            @click="columnClick(item, {label: item2.revisabilityName, property: item2.revisabilityName, index: index}, $event.target)"
          >
            <!-- 文件或图片 -->
            <template v-if="item2.type === 'file' || item2.type === 'image'">
              <div :class="isMobile ? 'name all' : 'fileImgNmae'">{{ item2.revisabilityName }}</div>
              <div :class="isMobile ? 'preimageList' : 'fileImgArea'">
                <div
                  class="detailItem"
                  v-for="(item3, index3) in item[
                  formNameChange(item2.revisabilityName)
                ]"
                  :key="index3"
                >
                  <!-- {{ showScope(scope) }} -->
                  <div class="name" @click.stop="preview(item3)">
                    <i class="iconfont icon-tianjiafujian"></i>
                    <div class="nameShow">
                      {{ fileNameShow(item3.response) }}
                    </div>
                    <div
                      class="upload"
                      @click="upload(item3)"
                      v-if="item2.type === 'file'"
                    >
                      <i class="iconfont icon-xiazai2x"></i>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <!-- 非文件或图片 -->
            <template v-else>
              <div :class="isMobile ? 'name' : 'normalName'">
                {{ formNameChange(item2.revisabilityName) }}
              </div>
              <div :class="isMobile ? 'value' : 'normalValue'">
                <!-- 数字单独写是因为 else 那边渲染不到，有问题 -->
                <div v-if="item2.type === 'number'" :style="[getColorNoe(item2, item[formNameChange(item2.revisabilityName)]), JSON.stringify(getColorNoe(item2, item[formNameChange(item2.revisabilityName)])) === '{}' ? numFormat({config:item2.configNumber, key:'color', numVal: item[formNameChange(item2.revisabilityName)], isFormatNum: item2.isFormatNum}) : '']">
                  {{numFormat({config: item2.configNumber, key: 'left', isFormatNum: item2.isFormatNum})}}{{ getFromNum(item[formNameChange(item2.revisabilityName)], item2.isFormatNum && item2.configNumber && item2.configNumber.separator, item2.configNumber) }}{{numFormat({config: item2.configNumber, key: 'right', isFormatNum: item2.isFormatNum})}}
                </div>
                <div v-else-if="item2.type === 'checkbox' && item2.isColor"
                     v-for="(its, itsIndex) in getCheckboxList(item, item2)"
                     :key="itsIndex + '_' + index + '_' + index2"
                     :style="getColorNoe(item2, its)">{{its}}</div>
                <div v-else-if="item2.type === 'dates' && item[formNameChange(item2.revisabilityName)]">
                  {{item[formNameChange(item2.revisabilityName)].split(',').join('/')}}
                </div>
                <div v-else-if="item2.type === 'displaylist' && item[formNameChange(item2.revisabilityName)]">
                  <template v-if="typeof item[formNameChange(item2.revisabilityName)] === 'string'">
                    {{ item[formNameChange(item2.revisabilityName)] }}
                  </template>
                  <template v-else>
                    <template v-for="(its, index) in item[formNameChange(item2.revisabilityName)]">
                      {{its.date}}&nbsp;[{{its.tick && its.tick === 10 ? timeDisplaylist10 [its.time[0]] : timeDisplaylist[its.time[0]]}}-{{its.tick && its.tick === 10 ? timeDisplaylist10 [its.time[1]] : timeDisplaylist[its.time[1] + 1]}}]{{index < item[formNameChange(item2.revisabilityName)].length - 1 ? ',' : ''}}
                    </template>
                  </template>
                </div>
                <div v-else :style="[getColorNoe(item2, item[formNameChange(item2.revisabilityName)]), item2.setIphone ? {color: '#057EFF'} : '']">
                  {{ getFromNum(item[formNameChange(item2.revisabilityName)], null, null) }}
                </div>
              </div>
            </template>
          </div>
          <div v-if="tableDetailData.type === 'detailed' && tableDetailData.relevance && tableDetailData.relevance.length > 0"
               :class="isMobile ? 'column-button' : 'styleItem vertical'">
            <template v-for="(item2, index2) in tableDetailData.relevance" :key="index2">
              <div v-if="index2 < 2  && isAppenBtn(item2, item)"
                   :class="isMobile ? 'column-button-b ellipsis' : ['table-button ellipsis', getButton(item2)]"
                   :style="getButtonStyle(item2)"
                   @click.stop="operate({$index: index, row: item}, item2)">
                <img v-if="item2.styleConfig && item2.styleConfig.icon && item2.styleConfig.style !== 'default'"
                     :src="'https://bigdata.topeti.com/PCRepository/middleground/home/icon/' + item2.styleConfig.icon" class="table-icon" />
                <template v-if="!item2.styleConfig || item2.styleConfig && item2.styleConfig.style !== 'icon'">
                  {{item2.styleConfig && item2.styleConfig.name ? item2.styleConfig.name : (item2.appName || item2.url)}}
                </template>
              </div>
            </template>
            <!-- 更多 -->
            <el-dropdown v-if="tableDetailData.relevance && tableDetailData.relevance.length > 2"
                         trigger="click"
                         :style="isMobile ? 'width:100%;margin-left:10px;margin-right:20px;' : ''"
                         @command="(val) => handleCommand({scope: {$index: index, row: item}, list: val})"
                         placement="bottom">
              <div v-if="isMobile" class="column-button-b mom">更多</div>
              <i v-else class="iconfont icon-xiangqing icon-mom"  />
              <template #dropdown>
                <el-dropdown-menu class="new-drop">
                  <template v-for="(list, index) in tableDetailData.relevance">
                    <el-dropdown-item v-if="index > 1"
                                      :key="index + 's'"
                                      :command="list">
                      {{list.styleConfig && list.styleConfig.name ? list.styleConfig.name : (list.appName || list.url)}}
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
        <div v-if="!tableDetailData.fromdatas || tableDetailData.fromdatas.length === 0" class="empty sj-center">
          <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
          <div>暂无数据</div>
        </div>
      </div>
    </el-scrollbar>
    <!-- 表格（列表、卡片布局） -->
    <el-scrollbar v-else :style="{
      height: `calc(100% - ${tableDetailData.showWay === 3 ? '1px' : '17px'})`,
      border: `${tableDetailData.showWay === 4 && (!iskd ? tableDetailData.fromdatas : configDate).length === 1 ? 'none' : '0'}`
    }" ref="myScrollbar">
<!--      :style="tableDetailData.tableModel === 'fixed' ? 'table-layout: fixed;' : ''"-->
      <div :style="{left: (wire + wireMove) + 'px', opacity: wire ? 1 : 0}" class="wire"></div>
      <div v-if="tableDetailData.showWay === 3"
           :class="['card-table', !isFrontEnd ? 'card-tr-back' : '', !isConfig ? 'card-tr-nodr' : '']">
        <div :class="['card-tr card-th', !isFrontEnd ? 'card-tr-back' : '']"
             :ref="tableDetailData.i + 'card'"
             :style="isFrontEnd ? 'backgroundColor:transparent' : ''">
          <div v-if="tableDetailData.reCheck" class="card-td" style="width: 50px">
            <div class="card-cell"
                 :style="[{backgroundColor: isFrontEnd ? 'transparent' : ''}, getAlign(tableDetailData.titleConfig), getFont(tableDetailData.titleConfig)]">
              序号
            </div>
          </div>
          <div class="card-td" v-for="(item, i) in tableDetailData.selectDatas"
               :key="item.title"
               :data-index="i"
               :style="{width: tableDetailData.tableModel ? getWidth(item, 'px') : ''}">
            <div class="card-cell"
                 :style="[{backgroundColor: (isFrontEnd ? 'transparent' : ''), maxWidth: tableDetailData.tableModel && tableDetailData.tableModel === 'fixed' ? 'inherit' : ''}, getAlign(tableDetailData.titleConfig), getFont(tableDetailData.titleConfig)]">{{item.revisabilityName}}</div>
            <span v-if="isConfig" class="td-move" @mousedown="adjustment($event, i)"></span>
          </div>
          <div v-if="tableDetailData.type === 'detailed' && tableDetailData.relevance && tableDetailData.relevance.length > 0"
               class="card-td" :style="{width: buttonWidth + 'px'}">
            <div :style="{
                  maxWidth: 'inherit',
                  backgroundColor: isFrontEnd ? 'transparent' : ''
                }">&nbsp;</div>
            <div class="card-cell card-float" :style="[{
                  paddingLeft: '6px',
                  paddingRight: 0,
                  backgroundColor: isFrontEnd ? 'transparent' : '',
                  width: buttonWidth + 'px'
                }, getAlign(tableDetailData.titleConfig), getFont(tableDetailData.titleConfig)]">操作</div>
          </div>
        </div>
        <template v-for="(list, index) in tableDetailData.fromdatas" :key="index">
          <div :class="['card-tr', !isFrontEnd ? 'card-tr-back' : '', index === selectedKey ? 'select-ed' : '']"
               @click="handleCurrentChange(list, index)">
            <div v-if="tableDetailData.reCheck" class="card-td">
              <div class="card-cell radius-one"
                   :style="[getAlign(tableDetailData.valueConfig), getFont(tableDetailData.valueConfig)]">
                {{index + 1}}
              </div>
            </div>
            <div class="card-td"
                 v-for="(item, i) in tableDetailData.selectDatas" :key="item.title">
              <div :class="['card-cell ellipsis',  !tableDetailData.reCheck && i === 0 ? 'radius-one' : '', i === 0 ? 'card-title' : '']"
                   :style="[item.isColor ? {textAlign: tableDetailData.valueConfig && tableDetailData.valueConfig.textAlign ? tableDetailData.valueConfig.textAlign : 'left', maxWidth: 'inherit'} : '']">
                <div v-if="item.type === 'image'">
                  <a v-for="(ites, itesIndex) in getValue(list, item)" :key="i+'im'+itesIndex"
                     style="cursor: pointer;"
                     class="card-a"
                     @click="preview(ites)">
                    {{ites.name || fileNameShow(ites.response)}}
                  </a>
                </div>
                <div v-else-if="item.type === 'file'">
                  {{getValue(list, item).map(its => its.name || its.response).join(',') || '&nbsp;'}}
                </div>
                <div v-else-if="item.type === 'dates' && getValueReady(list, item)"
                     :style="[getAlign(tableDetailData.valueConfig), getFont(tableDetailData.valueConfig)]">
                  {{getValueReady(list, item).split(',').join('/')}}
                </div>
                <div v-else-if="item.type === 'displaylist' && getValue(list, item)"
                     :style="[getAlign(tableDetailData.valueConfig), getFont(tableDetailData.valueConfig)]">
                    <template v-if="typeof getValue(list, item) === 'string'">
                    {{getValue(list, item)}}
                    </template>
                    <template v-else>
                    <template v-for="(its, index) in getValue(list, item)">
                      {{its.date}}&nbsp;[{{its.tick && its.tick === 10 ? timeDisplaylist10 [its.time[0]] : timeDisplaylist[its.time[0]]}}-{{its.tick && its.tick === 10 ? timeDisplaylist10 [its.time[1]] : timeDisplaylist[its.time[1] + 1]}}]{{index < getValue(list, item).length - 1 ? ',' : ''}}
                    </template>
                    </template>
                </div>
                <template v-else-if="item.type === 'checkbox' && item.isColor">
                  <div v-for="(its, index) in getCheckboxList(list, item)" :key="index"
                       :style="[getAlign(tableDetailData.valueConfig), getFont(tableDetailData.valueConfig), getColorNoe(item, its)]">{{its}}</div>
                </template>
                <div v-else-if="item.isColor" :style="[getAlign(tableDetailData.valueConfig), getFont(tableDetailData.valueConfig), getColor(item, {column: {property: item.revisabilityName}, row: list}), JSON.stringify(getColor(item, {column: {property: item.revisabilityName}, row: list})) === '{}' ? numFormat({config:item.configNumber, key:'color', numVal: getValue(list, item), isFormatNum: item.isFormatNum}) : '']">
                  {{numFormat({config: item.configNumber, key: 'left', isFormatNum: item.isFormatNum})}}{{getFromNum(getValue(list, item), item.isFormatNum && item.configNumber && item.configNumber.separator, item.configNumber)}}{{numFormat({config: item.configNumber, key: 'right', isFormatNum: item.isFormatNum})}}
                </div>
                <div v-else :style="[getAlign(tableDetailData.valueConfig), getFont(tableDetailData.valueConfig), numFormat({config:item.configNumber, key:'color', numVal: getValue(list, item), isFormatNum: item.isFormatNum})]">
                  {{numFormat({config: item.configNumber, key: 'left', isFormatNum: item.isFormatNum})}}{{getFromNum(getValue(list, item), item.isFormatNum && item.configNumber && item.configNumber.separator, item.configNumber)}}{{numFormat({config: item.configNumber, key: 'right', isFormatNum: item.isFormatNum})}}
                </div>
              </div>
            </div>
            <div class="card-td" v-if="tableDetailData.type === 'detailed' && tableDetailData.relevance && tableDetailData.relevance.length > 0" :style="getButtonConfig(index)">
              <div :style="{width: buttonWidth + 'px'}">&nbsp;</div>
              <div class="card-cell button-f card-float" :ref="'buttonF' + index" style="max-width: inherit;">
                <template v-for="(item, indexs) in tableDetailData.relevance" :key="indexs">
                  <div v-if="indexs < 2 && isAppenBtn(item, list)"
                       :class="['table-button ellipsis', getButton(item)]"
                       :style="getButtonStyle(item)"
                       @click.stop="operate({$index: index, row: list}, item)">
                    <img v-if="item.styleConfig && item.styleConfig.icon && item.styleConfig.style !== 'default'"
                         :src="'https://bigdata.topeti.com/PCRepository/middleground/home/icon/' + item.styleConfig.icon" class="table-icon" />
                    <template v-if="!item.styleConfig || item.styleConfig && item.styleConfig.style !== 'icon'">
                      {{item.styleConfig && item.styleConfig.name ? item.styleConfig.name : (item.appName || item.url)}}
                    </template>
                  </div>
                </template>
                <!-- 更多 -->
                <el-dropdown v-if="tableDetailData.relevance && tableDetailData.relevance.length > 2"
                             trigger="click"
                             @command="(val) => handleCommand({scope: {$index: index, row: list}, list: val})"
                             placement="bottom">
                  <i class="iconfont icon-xiangqing icon-mom"  />
                  <template #dropdown>
                    <el-dropdown-menu class="new-drop">
                      <template v-for="(list, index) in tableDetailData.relevance">
                        <el-dropdown-item v-if="index > 1"
                                          :key="index + 's'"
                                          :command="list">
                          {{list.styleConfig && list.styleConfig.name ? list.styleConfig.name : (list.appName || list.url)}}
                        </el-dropdown-item>
                      </template>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </div>
          </div>
          <div class="interval"></div>
        </template>
      </div>
      <div v-else-if="tableDetailData.showWay === 4" :style="width ? 'width:' + width + 'px' : ''">
        <tableCard :appid="tableDetailData.appId"
                   :config="tableDetailData.cardConfig"
                   :date="!iskd ? tableDetailData.fromdatas : configDate"
                   :relevance="tableDetailData.relevance || []"
                   :selectDatas="tableDetailData.selectDatas"
                   :isConfig="isConfig"
                   :cardAmount="tableDetailData.cardAmount"
                   :tableModel="tableDetailData.tableModel"
                   :user="tableDetailData.user"
                   :isDoor="isDoor"
                   @customizeButton="customizeButtonFun"
                   @dialog-close="$emit('dialog-close')"
                   @open-detail="handleCurrentChange"
                   @edit-user-info="editUserInfo"
                   @todo-inside="$emit('todo-inside', $event)"
                   @getOperate="({scope, item}) => operate(scope, item)" />
      </div>
      <div v-if="!tableDetailData.fromdatas || tableDetailData.fromdatas.length === 0" class="empty sj-center">
        <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
        <div>暂无数据</div>
      </div>
    </el-scrollbar>
    <multiple-choice
      ref="multipleChoiceRef"
      v-on:fromMultipleChoice="fromMultipleChoice"
      @close="clearActiveCol"
      v-show="isMultipleChoice">
    </multiple-choice>
  </div>
</template>

<script>
import { filePreview, getOrgShowName } from "@/api/global.js";
import { getLabelColor, filterStr, filterSymbol } from '@/api/instrumentControl'
import { generateTime, generateTime10, formatWY } from '@/api/utils'
import customRow from './titleBar/customRow.vue'
import orderAndScreen from '@/components/common/orderAndScreen'
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { cloneDeep } from "lodash";
import { defineAsyncComponent } from "vue";
import todoEdit from "@/components/schoolInstrument/component/mutual/component/form/todoEdit.vue";
import { openapiGetapproval } from '@/port/clientSide/applicationRouting.js'
import { updateapprovingbyfeild } from "@/port/clientSide/oaExamineAudit";
import multipleChoice from "@/components/common/multipleChoice"; //组织结构和角色选择
import { getUserParam } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { importData } from '@/components/admins/workBench/moreSetting/mycomponent/batchAddition/utils.js'

export default {
  name: 'tableDetail',
  inject: ['isFrontEnd'],
  directives: {
    // 'el-table-infinite-scroll': elTableInfiniteScroll
  },
  components: {
    tableCard: defineAsyncComponent(() => import('./tableCard/index.vue')),
    customRow,
    orderAndScreen,
    tableDetailCol: defineAsyncComponent(()=>import('../tableDetailCol.vue')),
    todoEdit,
    multipleChoice
  },
  props: {
    //- 明细表格数据
    tableDetailData: {
      type: Object,
      default: () => { return {} }
    },
    configDate: {
      type: Array,
      default: () => { return [] }
    },
    iskd: {
      type: Boolean,
      default: false
    },
    tableHeight: {
      type: String,
      default: ''
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    // 是否处于配置界面
    isConfig: {
      type: Boolean,
      default: () => false
    },
    width: {
      type: Number,
      default: 0
    },
    // 是否是门户
    isDoor: {
      type: Boolean,
      default: () => false
    },
    customDeskId: {
      type: [String, Number],
      default: 0
    }
  },
  data () {
    return {
      tableWidth: 0,
      tableCustomHeight: '100%',
      defaultStyleConfig: {
        name: '',
        style: 'default',
        size: 'min',
        color: '#38A2FB',
        icon: ''
      },
      buttonWidth: 0,
      moveX: 0,
      moveObj: null,
      wire: 0,
      wireMove: 0,
      timeDisplaylist: generateTime(),
      timeDisplaylist10: generateTime10(),
      tableHeaderWidth: 0,
      tableWidthCount: 0,
      selectedKey: '',
      lineClampMom: {},
      justifyObj: {
        left: 'flex-start',
        right: 'flex-end',
        center: 'center'
      },
      tableWidthConfig: {},
      curRow: {
        title: '',
        name: '',
        type: '',
        approvingId: ''
      },
      todoListConfig: {},
      approval: {},
      isMultipleChoice: false,
      isItAnObjectField: false,
      relationUserObj: {},
      tableKey: 0
    }
  },
  watch: {
    // 监听模式
    'tableDetailData.loadSetting': function () {
      this.modelFun()
    },
    'tableDetailData.showWay': function () {
      this.modelFun()
    },
    'tableDetailData.fromdatas': {
      deep: true,
      immediate: true,
      handler (val = []) {
        if (this.tableDetailData.showWay && this.tableDetailData.showWay === 1) {
          setTimeout(() => {
            this.getAW(val)
            if (this.tableDetailData.isChecked && this.tableDetailData.defaultAllCheck) {
              // eslint-disable-next-line vue/no-mutating-props
              this.tableDetailData.selectionList = cloneDeep(this.tableDetailData.fromdatas)
              this.$refs.table.toggleAllSelection();
            }
          }, 100)
        }
      }
    }
  },
  computed: {
    isWorkshop() {
      return this.tableDetailData.isSource === 2
    },
    getApprovalId() {
      if (!this.isWorkshop) {
        return this.tableDetailData.appId
      } else {
        const todo = this.todoListConfig[this.curRow.name]
        if (todo && todo.info.workshopInfo) {
          const workshopInfo = todo.info.workshopInfo
          return workshopInfo.appId
        } else {
          return ''
        }
      }
    },
    getCurWorkshop() {
      if (this.isWorkshop && this.todoListConfig[this.curRow.name]) {
        return this.todoListConfig[this.curRow.name].info.workshopInfo
      } else {
        return {}
      }
    },
    isNumFixed () {
      if (Array.isArray(this.selectDatas)) {
        const flag = this.selectDatas.some(item => item.fixed)
        return flag
      } else {
        return false
      }
    },
    isCustomExcel () {
      const config = this.tableDetailData.titleRowConfig || {}
      const flag = Object.keys(config).length !== 0
      return flag && this.tableDetailData.titleForRow === 'open'
    },
    getTableHeight () {
      const ref = this.$refs.customRow
      let h = '100%'
      if (ref) {
        const el = ref.$el
        h = `calc(100% - ${el.getBoundingClientRect().height}px)`
      }
      return h
    },
    selectDatas() {
      if (this.tableDetailData.customField) {
        return [...this.tableDetailData.selectDatas, ... this.tableDetailData.customField]
      } else {
        return this.tableDetailData.selectDatas
      }
    },
    // 行高显示判断
/*
    getLineHeight: function () {
      const obj = {
        // lineHeight: '22px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // display: '-webkit-box',
        // '-webkitBoxOrient': 'vertical',
        // '-webkitLineClamp' : 1,
        // height: this.tableDetailData.listHeight + 'px'
      }
      if (this.tableDetailData.listHeight) {
        // const val = Math.floor(this.tableDetailData.listHeight / 22)
        // obj['-webkitLineClamp'] = val || 1
        // obj.height = ((val || 1) * 22) + 'px'
      }
      return obj
    }
*/
  },
  mounted () {
    this.getTableWidth()
    this.modelFun()
    this.getCustomHeight()
    this.dealTodoConfig()
  },
  methods: {
    updateElTable() {
      this.tableKey++
    },
    async openRelationUserDialog(opt = {}) {
      const { item, scope, column, fatherName } = opt
      // 判断是否为对象字段
      this.isItAnObjectField = true
      // 获取对象路径
      const path = item.path
      // 修改字段信息
      const workshopInfo = column.info.workshopInfo
      if (workshopInfo) {
        // 获取当前需要修改的字段
        const formulaItem = workshopInfo.formula.find(f => f.name === item.name)
        if (formulaItem) {
          const changeFieldTitle = formulaItem.changeField.split('_')[0]
          let controlInfo = null
          if (formulaItem.appInfo.property) {
            controlInfo = formulaItem.appInfo.property.find(f => f.title === changeFieldTitle)
          } else {
            const property = await this.getAppInfo(formulaItem.appInfo.id || formulaItem.appInfo.approvalId)
            formulaItem.appInfo.property = property
            controlInfo = property.find(f => f.title === changeFieldTitle)
          }
          console.log(changeFieldTitle, controlInfo, 'controlInfo',  formulaItem.appInfo.property)
          const _info = {}
          _info.id = formulaItem.appInfo.id || formulaItem.appInfo.approvalId
          const pathLi = path.split('.')
          const strObj = this.tableDetailData.originalList[scope.$index]
          let value = strObj
          let approvingId = ''
          for (const p of pathLi) {
            if (value) {
              value = value[p]
              if (value && value['approving_id']) {
                approvingId = value['approving_id']
              }
            }
          }
          _info.info = value
          _info.data = controlInfo
          this.relationUserObj.formulaItem = formulaItem
          this.relationUserObj.approvingId = approvingId
          this.relationUserObj.path = path
          this.relationUserObj.scope = scope
          this.relationUserObj.item = item
          this.relationUserObj.fatherName = fatherName
          this.relationUserObj.approvalId = _info.id
          const param = getUserParam(_info)
          this.$refs.multipleChoiceRef.multipleChoiceMethod(param)
          this.isMultipleChoice = true
        }
      }
    },
    async fromMultipleChoice(resUser){
      const title = this.curRow.title
      let valArr = [];
      if(Object.prototype.hasOwnProperty.call(resUser, 'checkedUserArr')){
        resUser.checkedUserArr.forEach(el => {
          let elObj = {
            realname: el.realname,
            userId: el.userId
          };
          // 如果有组织信息
          if (el.orgname) elObj.orgname = el.orgname
          valArr.push(elObj);
        });
      } else if (Object.prototype.hasOwnProperty.call(resUser, 'checkedFlowArr')) {
        resUser.checkedFlowArr.forEach(el => {
          let elObj = {
            name: el.name,
            organizationId: el.organizationId,
            looktype: el.looktype || 0,
            type: el.type
          };
          valArr.push(elObj);
        });
      } else if (Object.prototype.hasOwnProperty.call(resUser, 'checkedRoleArr')) {
        resUser.checkedRoleArr.forEach(el => {
          let elObj = {
            name: el.name,
            roleId: el.roleId
          };
          valArr.push(elObj);
        });
      }
      if (!this.isWorkshop) {
        // 选择是表单
        const approvingId = this.tableDetailData.originalList[this.curRow.approvingId].approving_id
        const approvalId = this.getApprovalId
        const param = {
          approvalId,
          approvingId,
          feild: `${title}_${this.curRow.type}`,
          value: valArr
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.tableDetailData.fromdatas[this.curRow.approvingId][this.curRow.name] = valArr.map(item => item.realname).join(',')
        // eslint-disable-next-line vue/no-mutating-props
        this.tableDetailData.originalList[this.curRow.approvingId][this.curRow.name] = valArr
        await this.updateAppField(param)
      } else {
        if (!this.isItAnObjectField) {
          // 选择是工坊
          const oldRow = this.tableDetailData.originalList[this.curRow.approvingId]
          const row = this.tableDetailData.fromdatas[this.curRow.approvingId]
          if (this.getCurWorkshop.changeFieldId) {
            const name = this.getCurWorkshop.changeFieldId.split('_')[0]
            const approvingId = row[name]
            const approvalId = this.getApprovalId
            const param = {
              approvalId,
              approvingId,
              feild: `${title}_${this.curRow.type}`,
              value: valArr
            }
            await this.updateAppField(param)
            row[this.curRow.name] = valArr.map(item => item.realname).join(',')
            oldRow[this.curRow.name] = valArr
          } else {
            this.$message.error('无法确定修改数据')
          }
        } else {
          // 对象里面的联系人控件
          const { approvingId, approvalId, fatherName, formulaItem, item, path, scope} = this.relationUserObj
          if (approvingId) {
            const param = {
              approvalId,
              approvingId,
              feild: formulaItem.changeField,
              value: valArr
            }
            // eslint-disable-next-line vue/no-mutating-props
            this.tableDetailData.fromdatas[this.curRow.approvingId][fatherName] = valArr.map(item => item.realname).join(',')
            const path = this.relationUserObj.path
            const pathLi = path.split('.')
            let value = this.tableDetailData.originalList[this.curRow.approvingId]
            for (const p of pathLi) {
              value = value[p]
            }
            await this.updateAppField(param)
          } else {
            const addFormula = item.addFormula
            if (addFormula) {
              const opt = { row: scope.row, item, idx: scope.$index, path }
              const id = addFormula.appInfo.id || addFormula.appInfo.approvalId
              item.value = valArr.map(item => item.realname).join(',')
              item.realValue = valArr
              const formdata = this.getFormdata(opt)
              await importData([formdata], { approvalId: id })
              this.$emit('reload-page')
            }

          }
        }
      }
      this.clearActiveCol()
    },
    getFormdata(opt = {}) {
      const { row, item, idx, path } = opt
      const addFormula = item.addFormula
      const formdata = {}
      const rowLabel = path
      const otherName = item.otherName
      const newRow = { ...row, ...this.tableDetailData.originalList[idx] }
      for (const ele of addFormula.fieldMap) {
        const label = rowLabel.substring(0, rowLabel.lastIndexOf(otherName)) + ele.name
        let value = newRow[ele.name] || newRow[label] || ''
        if (ele.name === item.title) {
          value = item.realValue
          this.$set(row, label, item.value)
        }
        // const key = ele.targetField.substring(0, ele.targetField.lastIndexOf("_"))
        const key = ele.targetField
        if (key) {
          formdata[key] = value
        }
      }
      return formdata
    },
    async openUserDialog(opt = {}) {
      const { scope, column } = opt
      const _info = {}
      _info.id = this.getApprovalId
      const value = this.tableDetailData.originalList[scope.$index][column.name]
      let data = {}
      if (this.getCurWorkshop.appInfo && this.getCurWorkshop.appInfo.property) {
        data = this.getCurWorkshop.appInfo.property.find(f=>f.title === column.title)
      } else if (!this.getCurWorkshop.appInfo && this.getCurWorkshop.appId && this.getCurWorkshop.property) {
        const property = this.getCurWorkshop.property
        data = property.find(f => f.title === column.title)
      } else if (!this.getCurWorkshop.appInfo && this.getCurWorkshop.appId) {
        const property = await this.getAppInfo(this.getCurWorkshop.appId)
        this.getCurWorkshop.property = property
        console.log(property,'propertyproperty')
        data = property.find(f => f.title === column.title)
      } else {
        const property = await this.getAppInfo(this.getCurWorkshop.appInfo.id || this.getCurWorkshop.appInfo.approvalId)
        this.getCurWorkshop.appInfo.property = property
        data = property.find(f => f.title === column.title)
      }
      _info.data = data
      _info.info = value
      const param = getUserParam(_info)
      this.$refs.multipleChoiceRef.multipleChoiceMethod(param)
      this.isMultipleChoice = true
    },
    hideSecondLevelHeader ({ rowIndex }) {
      const showLevel = this.tableDetailData.showLevel || [1]
      if (!showLevel.includes(rowIndex + 1)) {
        return 'hidden-header'
      }
    },
    handleDetailCol(opt = {}){
      const { item, fatherName, idx } = opt
      this.curRow.title = fatherName
      this.curRow.approvingId = idx
      this.curRow.type = item.type
      this.curRow.name = item.name
    },
    clearActiveCol(){
      this.curRow.type = ''
      this.curRow.title = ''
      this.curRow.approvingId = ''
      this.relationUserObj = {}
      this.isItAnObjectField = false
    },
    async getAppInfo(id) {
      const approvalId = id || this.getApprovalId
      const param = {
        approvalId
      }
      const { code, data } = await openapiGetapproval(param)
      if (code === 0) { 
        if (!id) {
          this.$set(this, 'approval', data)
        }
        return typeof data.property === 'string' ? JSON.parse(data.property) : data.property
      }
    },
    async todoChange(val = {}) {
      const { row, column, value } = val
      if (!this.isWorkshop) {
        // 表单
        const param = {
          approvalId: this.getApprovalId,
          approvingId: row.approving_id,
          feild: `${column.title}_${column.type}`,
          value
        }
        await this.updateAppField(param)
      }
      this.todoReset()
    },
    async updateAppField(obj) {
      const res = await updateapprovingbyfeild(obj)
      if (res.code === 0) {
        this.$message.success('修改成功')
        return true
      } else {
        this.$message.error(res.msg)
      }
    },
    todoReset() {
      this.curRow = {
        title: '',
        name: '',
        type: '',
        approvingId: ''
      }
    },
    getLeafNodes(tree, childrenKey = 'list') {
      const leafNodes = [];
      
      function traverse(node) {
        if (!node) return;
        
        // 如果没有子节点或者子节点数组为空，说明是叶子节点
        if (!node[childrenKey] || node[childrenKey].length === 0) {
          leafNodes.push(node);
          return;
        }
        
        // 递归遍历所有子节点
        node[childrenKey].forEach(child => traverse(child));
      }
      
      traverse(tree);
      return leafNodes;
    },
    async dealTodoConfig () {
      if (this.tableDetailData.isTodoList) {
        let res = []
        if (!this.isWorkshop) {
          res = await this.getAppInfo()
        }
        for (const ele of this.tableDetailData.listTodoConfig) {
          const item = res.find(f => f.title === ele.title)
          if (!this.isWorkshop) {
            if (item) {
              const value = {
                ...item,
                info: ele.info
              }
              const name = ele.name
              this.todoListConfig[name] = value
            } else {
              this.todoListConfig[ele.name] = ele
            }
          } else {
            const name = ele.name
            this.todoListConfig[name] = ele
          }
        }
      }
    },
    goTodoEdit(opt = {}) {
      if (!this.tableDetailData.isTodoList) return
      const { e, scope, column } = opt
      const row = scope.row
      const info = this.todoListConfig[column.name]
      if (!info) return
      const obj = {
        title: info.title,
        name: info.name,
        type: info.type,
      }
      obj.approvingId = scope.$index
      this.$set(this, 'curRow', obj)
      if (info.type === 'relation-user') {
        this.openUserDialog(opt)
      } else {
        this.$nextTick(() => {
          let rect = {}
          let cell = e.target
          if (cell) {
            rect = cell.getBoundingClientRect()
          }
          this.$refs.todoEditRef[0].open({ row, column: info, rect, isName: true })
        })
      }
    },
    goSearch(filed, info) {
      const { revisabilityName, type } = filed
      const { type: infoType, value } = info
      const orderValue = {
        positiveSequence: 'asc',
        reverseOrder: 'desc'
      }
      const query = []
      const order = []
      if (infoType === 'order') {
        const obj = {}
        obj.key = orderValue[value] 
        obj.value = orderValue[value] 
        obj.feild = revisabilityName
        obj.setting = revisabilityName
        order.push(obj)
      } else {
        const obj = {}
        console.log(type);
        
        if (type === 'date') {
          obj.value = value
        } else {
          obj.value = [value]
        }
        obj.relation = 'in'
        obj.field = revisabilityName
        if (value) {
          query.push(obj)
        }
      }
      this.$emit('goSearch', { query, order, val: this.tableDetailData })
    },
    getCustomHeight () {
      if (this.tableDetailData.titleForRow === 'open') {
        this.$nextTick(() => {
          setTimeout(() => {
            this.tableCustomHeight = this.getTableHeight
          }, 400)
        })
      }
    },
    getIcon (cc) {
      const { label, realWidth } = cc.column
      return this.tableWidthConfig[label] && this.tableWidthConfig[label] > realWidth
    },
    getAW (val) {
      let w = {}
      for (const i of val) {
        w = this.getW(i, w)
      }
      this.tableWidthConfig = w
    },
    getV (val, s) {
      if (!val && val !== 0) return ''
      if (val && typeof val === 'object' && !Array.isArray(val)) {
        s.push(Object.keys(val)[0])
        return this.getV(Object.values(val)[0])
      } else {
        s.push(Object.keys(val)[0])
        return val
      }
    },
    getW (ob, w) {
      for (const i in ob) {
        let e = []
        const s = this.getV(ob[i], e)
        if (typeof i !== 'object') e = [i]
        const str = e.join('.')
        const f = (this.tableDetailData.valueConfig.fontWeight || 400) + ' ' + (this.tableDetailData.valueConfig.fontSize || '14px') + ' arial'
        const sw = this.getWidthCanvas(s, f) + 20
        if (!w[str] || w[str] < sw) {
          w[str] = sw
        }
      }
      return w
    },
    isAppenBtn(list, row) {
      let customData = []
      if (this.isDoor) {
        customData = this.$store.state.doorCustomDataObj[this.customDeskId] || undefined
      }
      return isConditionAppen(list.conditionAppen, row, true, customData) 
    },
    getIconRight (width, config) {
      let w = 0
      const c = this.tableDetailData.valueConfig || {}
      for (const i of (this.tableDetailData.fromdatas || [])) {
        if (i[config.revisabilityName]) {
          const w1 = this.getWidthCanvas(i[config.revisabilityName], (c.fontWeight + ' ' + c.fontSize + ' arial')) + 20
          if (w1 > w) w = w1
        }
      }
      return w > width
    },
    customizeButtonFun (e) {
      if (!e.id) e.id = this.tableDetailData.i
      this.$emit('customizeButton', e)
    },
    getXhWidth () {
      let w = 0
      if (!this.tableDetailData.tableModel || this.tableDetailData.tableModel === 'default') {
        if (this.tableDetailData.raCheckWidth) {
          w = (this.tableDetailData.raCheckWidth < 30 ? 30 : this.tableDetailData.raCheckWidth) + 'px'
        }
      } else {
        if (this.tableDetailData.raCheckWidth) {
          w = Math.ceil(this.tableWidth * this.tableDetailData.raCheckWidth / 100) + 'px'
        }
      }
      return w || '50px'
    },
    clampMom (key) {
      this.lineClampMom[key] = !this.lineClampMom[key]
    },
    // 表格选中行
    handleCurrentChange (val, index) {
      console.log('表格选中行', val, index)
      if (!this.tableDetailData.showWay || this.tableDetailData.showWay === 1) {
        setTimeout(() => {
          this.$emit('selectedTable', {val: val, index: this.selectedKey})
        }, 10);
      } else {
        this.selectedKey = index
        this.$emit('selectedTable', {val: val, index: index})
      }
    },
    // 表格多选
    handleSelectChange (selection) {
      // eslint-disable-next-line vue/no-mutating-props
      this.tableDetailData.selectionList = cloneDeep(selection)
    },
    getFromNum (val, key, config) {
      if (config && (config.value === 'currency' && config.currency === '万元')) val = formatWY(val)
      if (key && !isNaN(Number(val))) val = this.numFormatFun(val)
      if (Array.isArray(val) && val[0] && (val[0].name ||val[0].realname)) {
        // 是组织或者联系人、角色
        val = val.map(item => {
          if (item && item.organizationId) {
            return getOrgShowName(item)
          } else {
            return item.name || item.realname
          }
        }).join()
      }
      return config && config.value && config.value === 'percentage' ? (val * 100).toFixed(config.decimal || 0) : val
    },
    // 数字格式设置
    numFormat ({config, key = 'left', numVal, isFormatNum}) {
      if (config && isFormatNum) {
        switch (key) {
          case 'color':
            return config.value && config.value !== 'percentage' && config.markedRed && Number(numVal) < 0 ? {color: '#ff0000'} : ''
          case 'left':
            return (config.value === 'currency' || config.value === 'accounting') && config.currency !== '万元' ? config.currency : ''
          case 'right':
            return config.value === 'number' && (config.customSymbols || config.customSymbols === 0) ? config.customSymbols : config.value === 'percentage' ? '%' : config.value === 'currency' && config.currency  === '万元' ? '万元' : ''
        }
      }
    },
    // 宽度调整
    adjustment (e, key) {
      const table = this.$refs.myScrollbar.wrap.getBoundingClientRect()
      const eWire = e.target.getBoundingClientRect()
      this.moveX = e.pageX
      this.moveObj = key
      this.wire = eWire.left - table.left
      document.onmousemove = this.move
      document.onmouseup = this.seup
    },
    // 监听移动
    move (e) {
      this.wireMove = e.pageX - this.moveX
    },
    // 放开
    seup (e) {
      console.log('放开，注销事件', e)
      const w = this.tableDetailData.selectDatas[this.moveObj].width + this.wireMove
      const _tableDetailData = cloneDeep(this.tableDetailData)
      if (this.tableDetailData.tableModel && this.tableDetailData.tableModel === 'fixed') {
        const table = this.$refs[this.tableDetailData.i + 'card']
        if (table) {
          const td = table.getElementsByClassName('card-td')
          // 差值(如果是正数则计算递减值，负数则计算递加值)
          const cW = this.wireMove / ((this.tableDetailData.selectDatas.length - 1) - (this.moveObj + 1))
          console.log('表格整体宽度', table.clientWidth, td, cW, this.wireMove)

          const selectDatas = JSON.parse(JSON.stringify(this.tableDetailData.selectDatas))
          for (const i of td) {
            const index = i.dataset.index
            let w = 0
            if (index || index === 0) {
              if (Number(index) === this.moveObj) {
                w = Math.round((i.clientWidth + this.wireMove) / (table.clientWidth - this.buttonWidth) * 10000) / 100
                selectDatas[this.moveObj].width = w
              } else if (Number(index > this.moveObj)) {
                w = Math.round((i.clientWidth - cW) / (table.clientWidth - this.buttonWidth) * 10000) / 100
                selectDatas[Number(index)].width = w
              }
              // console.log('查看i', w, index)

              // if (index || index === 0) selectDatas[Number(index)].width = w
            }
          }
          _tableDetailData.selectDatas = selectDatas
        }
      } else {
        _tableDetailData.selectDatas[this.moveObj].width = w
      }
      this.$emit('update:tableDetailData', _tableDetailData)
      this.moveX = 0
      this.moveObj = null
      this.wire = 0
      this.wireMove = 0
      document.onmousemove = null
      document.onmouseup = null
    },
    // 初始化宽度(只有列表后台配置使用)
    inquireWidth () {
      if (this.tableDetailData.showWay === 3) {
        const table = this.$refs[this.tableDetailData.i + 'card']
        if (table) {
          const td = table.getElementsByClassName('card-td')
          console.log('表格整体宽度', table.clientWidth, td)
          for (const i of td) {
            i.style.width = i.clientWidth + 'px'
          }
        }
      }
    },
    // 按钮宽度
    getButtonConfig (index) {
      if (index === 0) {
        this.$nextTick(() => {
            const dom = this.$refs['buttonF' + index]
            if (dom && dom[0]) this.buttonWidth = dom[0].clientWidth + 10
        })
      }
    },
    // 对齐方式查询
    getAlign (item, key) {
      const obj = {
        height: this.tableDetailData.listHeight + 'px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: item && item.textAlign ? item.textAlign : 'left'
      }
      if (key) obj.justifyContent = 'center'
      return obj
    },
    // 查询文字设置样式
    getFont (item, key) {
      if (!item) return {}
      const obj = JSON.parse(JSON.stringify(item))
      // obj.lineHeight = this.tableDetailData.listHeight + 'px'
      // delete obj.textAlign
      if (key) obj.textAlign = 'center'
      return obj
    },
    // 模式值判断
    modelFun () {
      if (this.tableDetailData.loadSetting && this.tableDetailData.loadSetting === 'scroll' && (this.tableDetailData.showWay && (this.tableDetailData.showWay === 3 || this.tableDetailData.showWay === 4))) {
        setTimeout(() => {
          if (this.$refs.myScrollbar && this.$refs.myScrollbar.wrap) {
            const scrollbarEl = this.$refs.myScrollbar.wrap
            scrollbarEl.onscroll = (el) => {
              this.scrollAddEvent(el)
            }
          }
        }, 100)
      }
/*
      if (this.tableDetailData.showWay === 3) {
        this.inquireWidth()
      }
*/
    },
    // scrollbar 滚动监听
    scrollAddEvent (el) {
      const offsetHeight = el.target.offsetHeight
      const scrollTop = el.target.scrollTop
      const scrollHeight = el.target.scrollHeight
      if ((offsetHeight + scrollTop) >= scrollHeight) {
        this.load()
      }
    },
    load () {
      if (this.tableDetailData.loadSetting && this.tableDetailData.loadSetting === 'scroll' && !this.tableDetailData.skeletonLoading && this.tableDetailData.pageTotal > this.tableDetailData.fromdatas.length) this.$emit('loadPage', this.tableDetailData)
    },
    getValueReady (value, item) {
      const its = filterSymbol(item.revisabilityName || item.name)
      const its1 = (item.revisabilityName || item.name).split('.').join('')
      return value[its] || value[its] === 0 ? value[its] : value[item.revisabilityName || item.name] || value[its1]
    },
    getValue (value, item) {
      const its = filterStr(item.revisabilityName || item.name)
      const its1 = (item.revisabilityName || item.name).split('.').join('')
      return value[its] || value[its] === 0 ? value[its] : value[item.revisabilityName || item.name] || value[its1]
    },
    // 计算checkbox 值
    getCheckboxList (value, item) {
      // 去除特殊字符
      const its = filterStr(item.revisabilityName || item.name)
      const val = value[its]
      return val && typeof val === 'string' ? val.split(',') : []
    },
    getTableWidth () {
      try {
        if (this.$refs.table) {
          const tableDom = this.$refs.table.$el
          this.tableWidth = tableDom.clientWidth
          const tableHeader = tableDom.getElementsByClassName('el-table__header-wrapper')
          if (tableHeader && tableHeader[0]) {
            setTimeout(() => {
              if (tableHeader[0].getElementsByClassName('has-gutter')[0]) {
                this.tableHeaderWidth = tableHeader[0].getElementsByClassName('has-gutter')[0].clientWidth
              }
            }, 100)
          }
          // 如果是固定宽度模式，校队一次表格百分比(计算出每一列分配的宽度)
          if (this.tableDetailData.tableModel && this.tableDetailData.tableModel === 'fixed' && this.tableDetailData.operateWidth && this.tableDetailData.relevance && this.tableDetailData.relevance.length > 0) {
            let count = 0
            for (const i of this.tableDetailData.selectDatas) {
              if (i.width) count += i.width
            }
            // 剩余的可分配宽度
            const sy = (100 - count) / 100 * this.tableWidth - this.tableDetailData.operateWidth
            const len = this.tableDetailData.reCheck ? this.tableDetailData.selectDatas.length + 1 : this.tableDetailData.selectDatas.length
            this.tableWidthCount = sy / this.tableWidth * 10000 / len / 100
          }
          console.log('表格数据', tableDom)
        }
      } catch(e) {
        console.log(e)
      }
    },
    getWidths (arr) {
      let w = 0
      let count = 0
      for (const i of arr) {
        // console.log('判断当前按钮是否显示', this.getShowButton(i))
        if (!this.isFrontEnd && i.conditionAppen) {
          const aa = this.getShowButton(i)
          if (aa) {
            const wi = this.getWidthCanvas(i.styleConfig && i.styleConfig.name ? i.styleConfig.name : (i.appName || i.url), 'bold 14px arial') + (i.styleConfig.style === 'text' ? 8 : 34)
            count += 1
            w += wi
          }
        } else {
            const wi = this.getWidthCanvas(i.styleConfig && i.styleConfig.name ? i.styleConfig.name : (i.appName || i.url), 'bold 14px arial') + (i.styleConfig.style === 'text' ? 8 : 34)
            count += 1
            w += wi
        }
      }
      if (arr.length === 1 && arr[0].styleConfig.style === 'text') w += 8
      return (w + (count * 10 + 10)) + 'px'
      // return (w + (arr.length * 10 + 10)) + 'px'
      // 写判断是因为要兼容老的数据
      // console.log(this.tableDetailData.operateWidth)
      // if (this.tableDetailData.operateWidth && typeof this.tableDetailData.operateWidth === 'string' && this.tableDetailData.operateWidth.includes('px')) {
      //   return this.tableDetailData.operateWidth
      // }
      // let w = arr.length > 2 ? 30 : 0
      // const obs = {
      //   min: 103,
      //   max: 128
      // }
      // for (let i = 0; i < arr.length; i++) {
      //   if (i > 1) break
      //   const size = i.styleConfig && i.styleConfig.size || 'min'
      //   const val = obs[size || 'min']
      //   w += val
      // }
      // return w
    },
    getWidthCanvas (str, font) {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      context.font = font
      const metrics = context.measureText(str)
      return metrics.width
    },
    getShowButton (item) {
      for (const i of this.configDate || []) {
        const ia = this.isAppenBtn(item, i)
        if (ia) return true
      }
      return false
    },
    handleCommand (item) {
      if (!this.isFrontEnd) this.operate(item.scope, item.list)
    },
    getButtonStyle (item) {
      const styleConfig = item.styleConfig || this.defaultStyleConfig
      const obs = {
        color: styleConfig.color,
        borderColor: styleConfig.color,
        backgroundColor: 'transparent',
        // 按钮文本要显示完全
        overflow: 'unset'
      }
      if (styleConfig.style === 'default') {
        obs.color = '#ffffff'
        obs.backgroundColor = styleConfig.color
      } else if (styleConfig.style === 'text') {
        obs.paddingLeft = '6px'
        obs.paddingRight = '6px'
        obs.marginRight = '0'
      } else {
        obs.borderWidth = '1px'
        obs.borderStyle = 'solid'
      }
      if (styleConfig.style === 'text') {
        obs.fontSize = '14px'
      }
      return obs
    },
    // 查询按钮样式
    getButton (item) {
      const styleConfig = item.styleConfig || this.defaultStyleConfig
      const size = {
        min: ' button-size-min',
        max: ' button-size-max'
      }
      return size[styleConfig.size]
    },
    editUserInfo (index, editUser) {
      const value = this.tableDetailData.user[index]
      this.$emit("edit-user", editUser, value)
    },
    // 点击操作
    operate (scope, item) {
      console.log('点击操作', scope, item, this.tableDetailData.user)
      if (item.bindingFunction === 'edit-user' || item.link === 6) {
        const { editUser } = item
        const value = this.tableDetailData.user[scope.$index]
        this.$emit("edit-user", editUser, value)
        return false
      }
      // 单个点击操作另外走
      if (this.tableDetailData.selectDatas && this.tableDetailData.selectDatas.length > 0) {
        // 返回当前点击的配置项（直接查找对应配置插入数据）
        // 做一次数据匹配
        if (item.linked && item.linked.length > 0) {
          item.linked = item.linked.map(its => {
            // 匹配的数据
            const index = this.tableDetailData.selectDatas.findIndex(ites => ites.title === its.title)
            if (index !== -1) {
              its.revisabilityName = this.tableDetailData.selectDatas[index].revisabilityName
            }
            return its
          })
        }
        if (item.customize && item.customize.length > 0) {
          item.customize = item.customize.map(its => {
            // 匹配的数据
            const index = this.tableDetailData.selectDatas.findIndex(ites => ites.title === its.title)
            if (index !== -1) {
              its.revisabilityName = this.tableDetailData.selectDatas[index].revisabilityName
            }
            return its
          })
        }
        const date = {
          value: scope.row,
          item: item,
          id: this.tableDetailData.i
        }
        if (this.tableDetailData.user) date.user = this.tableDetailData.user[scope.$index]
        console.log('点击返回', date)
        this.$emit("singleRelevance", date)
      }
    },
    // 计算当前宽度
    getWidth (item, key) {
      const w = item.width ? item.width : (item.type === 'file' || item.type === 'image' ? 250 : item.width || 170)
      if (key) {
        return !this.tableDetailData.tableModel || this.tableDetailData.tableModel === 'default' ? w + 'px' : (w + '%')
      } else {
        // let str = w
        // if (this.tableDetailData.tableModel && this.tableDetailData.tableModel === 'fixed') {
        //   str += this.tableDetailData.tableWidthCount
        //   str += '%'
        // }
        return w
        // return !this.tableDetailData.tableModel || this.tableDetailData.tableModel === 'default' ? w : (w + '%')
      }
    },
    getColorNoe (item, val) {
      if (item.isColor && item.options && (val || val === 0)) {
        const obs = getLabelColor(item, val, undefined, item.colorType)
        // obs.lineHeight = 'initial'
        // console.log('返回匹配', obs, val, item)
        return obs
      }
      return {}
    },
    getColor (item, scope) {

      const property = scope.column.property;
      const val = scope.row[property]

      return this.getColorNoe(item, val)
    },
    columnClick(row, column, cell, event){
      console.log('点击', row, column, cell, event)

      // 当前是明细表的话，禁止点击（显示方式，经典布局）
      if (this.tableDetailData.type === 'detailed' && this.tableDetailData.showWay === 1) {
        const dom = cell.getElementsByClassName('zdysy')
        if (dom) this.selectedKey = dom[0]?.getAttribute('data-index')
        return false
      }
      let value = row[column.property];
      if((!value && value !== 0 || cell.className.indexOf("cllDark") != -1) && value !== 0){
        return;
      }
      if (this.tableDetailData.selectDatas && this.tableDetailData.selectDatas.length > 0) {
        const date = {
          id: this.tableDetailData.i,
          value: row,
          label: column.label
        }
        if (this.tableDetailData.user) date.user = this.tableDetailData.user[column.index]
        console.log('点击返回', date)
        this.$emit("relevanceFun",date)
      }

    },
    //- 文件名称显示
    fileNameShow (name) {
      if (!name) return '';
      if (typeof name === 'string' && name.indexOf("-") !== -1) {
        let arr = name.split('-');
        arr.shift();
        let last = arr.join("-");
        return last
      } else {
        return name
      }
    },
    //- 文件下载
    upload (val) {
      filePreview(val, true)
    },
    //- 文件预览
    preview (val) {
      filePreview(val)
    },
    //- 判断非文件，图片当前单元格显示数据
    scopeNameFun (scope, key, config) {
      // console.log("scope====>", scope, key, config)
      const property = scope.column.property;
      let val = scope.row[property] === '' ? '暂无数据' : scope.row[property]
      val = Array.isArray(val) ? val.map(item => { 
        let data = item.name || item 
        if (item && item.organizationId) {
          data = getOrgShowName(item)
        }
        return data
      }).join() : val
      try {
        if (config && config.separator) val = val.toFixed(config.separator)
      } catch (err) { /* console.log(err, val) */ }
      if (val && config && (config.value === 'currency' && config.currency === '万元')) val = formatWY(val)
      if (key && !isNaN(Number(val))) val = this.numFormatFun(val)
      return config && config.value && config.value === 'percentage' ? (val * 100).toFixed(config.decimal || 0) : val
    },
    numFormatFun(num){
      const res = num.toString().replace(/\d+/, function(n){ // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
          return $1+",";
        });
      })
      return res;
    },
    //- 判断当前单元格数据类型
    // scopeTypeFun (scope) {
    //   let selectDatas = this.tableDetailData.selectDatas;
    //   let label = scope.column.label;
    //   let index = selectDatas.findIndex((findItem, findIndex) => {
    //     return findItem.revisabilityName === label
    //   })
    //   console.log("selectDatas[index].type====>", selectDatas[index].type)
    //   return index != -1 ? selectDatas[index].type : 'text'
    // },
    //- 表格背景色斑马纹
    getRowClass ({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        //- 偶数
        return 'normal';
      } else {
        //- 奇数
        return 'light';
      }
    },
    //- 序号判断
    indexMethod (index) {
      let curpage = this.tableDetailData.curpage   //单前页码，具体看组件取值
      let limitpage = this.tableDetailData.article   //每页条数，具体是组件取值
      // return (index+1) + (curpage-1)*limitpage
      return (curpage - 1) * limitpage + index + 1
    },
    //- 表格名称格式修改
    formNameChange (val) {
      let new_val = val.split(".");
      new_val = new_val.join("");
      return new_val
    },
    headerDragend(newWidth, oldWidth, column){
      const _tableDetailData = cloneDeep(this.tableDetailData)
      if (this.tableDetailData.tableModel && this.tableDetailData.tableModel === 'fixed') {
        const arr = JSON.parse(JSON.stringify(this.tableDetailData.selectDatas))
        // 如果是固定，需要重新确认一次各个表格的宽度
        this.$refs.table.columns.forEach((its, index) => {
          const w = Math.round((its.width || its.realWidth) / this.tableWidth * 10000) / 100
          const len = this.tableDetailData.reCheck ? index - 1 : index
          // 开启序号，第一个抛弃
          if (this.tableDetailData.reCheck && index === 0) {
            _tableDetailData.raCheckWidth = w
          } else {
            console.log('宽', w)
            if (!arr[len]) {
              // 不存在就代表是操作列的(操作列大小是固定的，直接存固定px)
              console.log('固定按钮款',its.width || its.realWidth)
              _tableDetailData.operateWidth = (its.width || its.realWidth) + 'px'
            } else {
              arr[len].width = w
            }
          }
        })
        _tableDetailData.selectDatas = arr
      } else {
        if (typeof column.index === 'function' || !column.index && column.index !== 0) {
          _tableDetailData.raCheckWidth = newWidth
        } else {
          _tableDetailData.selectDatas[column.index].width = newWidth
        }
      }
      this.$emit('update:tableDetailData', _tableDetailData)
    }
  },
}
</script>

<style scoped lang="scss">

.detail-header {
  :deep(.icon-xia) {
    opacity: 0;
  }
  &:hover :deep(.icon-xia)  {
    opacity: 1;
  }
}

:deep(.custom-table-title) {
  .has-gutter {
    display: none;
  }
  .el-table__fixed-right {
    .el-table__fixed-header-wrapper {
      display: none;
    }
    .el-table__fixed-body-wrapper {
      height: 100%;
      .el-table__body {
        height: 100%;
      }
    }
  }
}
.header-mom {
  position: absolute;
  right: 0;
  // right: -7px;
  top: 0;
  // top: 50%;
  font-size: 12px;
  color: #d8d8d8;
  cursor: pointer;
}
.customization-clamp {
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  // -webkit-line-clamp: none;
  white-space: normal;
  transition: 0.3s;
}
:deep(.current-row td) {
  background-color: #EBEEF5 !important;
}
:deep(.el-table__empty-block) {
  width: 100% !important;
}
.empty {
  line-height: 30px;
}
.sj-center {
  position: absolute;
  top: calc(50% - 55px);
  left: calc(50% - 36px);
  color: #99A3AD;
  text-align: center;
}
.td-move {
  height:60%;
  border-right: 1px solid #cccccc;
  width: 1px;
  display: inline-block;
  position: absolute;
  right: 0;
  top: 20%;
  cursor: col-resize;
}
.wire {
  position: absolute;
  height: calc(100% - 15px);
  width: 1px;
  z-index: 1;
  left: -10px;
  border-right: 1px solid red;
}
.card-a {
  color: #2086da;
  &:hover {
    text-decoration: underline;
  }
}
.card-table {
  display: table;
  width: calc(100% - 15px);
  background-color: #f7f9fa;
  position: relative;
  table-layout: fixed;
  .card-th {
    .card-td {
      border: none !important;
      position: relative;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .card-cell {
        color: #85888B;
        font-size: 14px;
        line-height: 26px;
        padding-bottom: 16px;
        background-color: #F7F9FA;
        white-space: nowrap;
      }
    }
  }
  .card-tr {
    display: table-row;
    box-shadow: 0px 2px 4px rgba(224, 224, 224, 0.13);
    position: relative;
    background-color: #FFFFFF;

    .card-td {
      display: table-cell;
      position: relative;
      vertical-align: middle;
      .card-cell {
        //max-width: 190px;
        background-color: #FFFFFF;
        padding: 11px 12px;
        //padding: 19px 12px;
        line-height: 22px;
        color: #85888B;
        min-width: 50px;
      }
      .button-f {
        display: flex;
        align-items: center;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        padding: 3px 0;
        line-height: 32px;
      }
      .radius-one {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
    .card-title {
      color: #33393E !important;
      font-weight: bold;
      // max-width: 236px !important;
    }
    .card-float {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .select-ed {
    background-color: #edf4fd;
    .card-td {
      background-color: #edf4fd;
      .card-cell {
        background-color: #edf4fd !important;
      }
    }
  }
  .interval {
    height: 16px;
  }
}
.card-tr-nodr {
  background-color: #FFFFFF;
  width: 100%;
  .card-td {
    border-top: 1px solid #EEEEEE;
    border-bottom: 1px solid #EEEEEE;
    &:first-child {
      border-left: 1px solid #EEEEEE;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border-right: 1px solid #EEEEEE;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
}
.card-tr-back {
  background-color: #FFFFFF;

  .card-cell {
    background-color: #FFFFFF !important;
  }
  .card-td {
    border-bottom: 1px solid #EEEEEE;
    border-top: 1px solid #EEEEEE;
    &:last-child {
      border-right: 1px solid #EEEEEE;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    &:first-child {
      border-left: 1px solid #EEEEEE;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
}

.button-size-max, .button-size-min {
  line-height: 20px;
  border-radius: 4px;
  display: inline-block;
}
.button-size-max {
  padding: 5px 24px;
}
.button-size-min {
  padding: 3px 16px;
}
.tableDetail {
  height: calc(100% - 5px);
  // height: 85%;
  margin-top: 5px;
  width: calc(100% - 10px);
  :deep(.el-scrollbar__wrap) {
    height: calc(100% + 17px);
  }
  .tabStyleArea {
    width: calc(100% + 10px);
    height: 97%;
    overflow-y: scroll;
    margin: 1px;
    .styleGroup {
      width: calc(100% - 40px);
      background: #ffffff;
      box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      display: inline-block;
      margin: 10px 10px 10px 10px;
      padding: 10px 10px;
      .styleItem {
        width: 100%;
        border-bottom: 1px solid #d8d8d8;
        display: inline-block;
        position: relative;
        min-height: 40px;
        color: #333333;
        // padding: 0 12px;
        .fileImgNmae {
          width: 100%;
          text-align: left;
          display: inline-block;
          margin: 12px 0 2px;
        }
        .fileImgArea {
          width: 100%;
          .detailItem {
            width: 100%;
            display: inline-block;
            .name {
              width: 96%;
              line-height: 30px;
              display: inline-block;
              i {
                display: inline-block;
                color: #2086da;
              }
              .nameShow {
                max-width: 88%;
                display: inline-block;
                vertical-align: top;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                height: 30px;
                color: #2086da;
                cursor: pointer;
                &:hover {
                  text-decoration: underline;
                }
              }
              .upload {
                width: 3%;
                line-height: 30px;
                display: inline-block;
                vertical-align: top;
                text-align: center;
                color: #2086da;
                cursor: pointer;
              }
            }
          }
        }

        .normalName {
          width: 40%;
          float: left;
          height: auto;
          text-align: left;
          display: inline-block;
          position: absolute;
          top: 50%;

          transform: translateY(-50%);
        }
        .normalValue {
          width: 40%;
          float: right;
          height: auto;
          margin: 12px 0;
          text-align: right;
          display: inline-block;
        }
      }
      .vertical {
        display: flex;
        align-items: center;
        justify-content: right;
      }
    }
  }
  .table-button {
    display: inline-block;
    align-items: center;
    margin-right: 8px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    .table-icon {
      width: 16px;
      font-size: 16px;
      vertical-align: text-bottom;
    }
  }
  .icon-mom {
    font-size: 24px;
    color: #929292;
    cursor: pointer;
  }
  :deep(.el-scrollbar__wrap) {
    padding-right: 2px;
  }
}
:deep(.el-table) {
  color: #333333;
  height: calc(100% - 5px) !important;
  .normal {
    background: #ffffff;
  }
  .light {
    background: #fbfcfd;
  }
  .detail {
    width: 100%;
    .detailItem {
      width: 100%;
      height: auto;
      display: inline-block;
      .name {
        width: 79%;
        line-height: 30px;
        display: inline-block;
        i {
          display: inline-block;
          color: #999999;
        }
        span {
          width: 89%;
          display: inline-block;
          vertical-align: top;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          height: 30px;
          color: #2086da;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .upload {
        width: 20%;
        line-height: 30px;
        display: inline-block;
        vertical-align: top;
        float: right;
        text-align: center;
        color: #2086da;
        cursor: pointer;
      }
    }
  }
  .cz-button {
    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
:deep(.el-table td),
:deep(.el-table th) {
  padding: 3px 0 !important;
}
/*
:deep() .card-table {
  th {
    padding: 8px !important;
  }
}
*/
/*修改滚动条样式*/
:deep(.tabStyleArea::-webkit-scrollbar) {
  width: 10px;
  height: 10px;
  /**/
}

:deep(.tabStyleArea::-webkit-scrollbar-track) {
  background: transparent;
  border-radius: 2px;
}

:deep(.tabStyleArea::-webkit-scrollbar-thumb) {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

:deep(.tabStyleArea::-webkit-scrollbar-thumb:hover ) {
  background: rgba(0, 0, 0, 0.5);
}

:deep(.tabStyleArea::-webkit-scrollbar-corner) {
  background: transparent;
}

.columnArea {
  width: 100%;
  height: 50%;
  display: inline-block;
}
.columnArea .columnGroup {
  width: calc(100% - 64px);
  background: #FFFFFF;
  border-radius: 4px;
  margin: 10px 16px 0 16px;
  padding: 4px 16px;
}
.columnArea .columnGroup .column-button {
  padding-top: 4px;
  margin-top: -1px;
  border-top: 1px solid #ffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
}
.columnArea .columnGroup .column-button .column-button-b {
  padding: 9px;
  font-size: 14px;
  border-radius: 4px;
  text-align: center;
  width: 100%;
  margin-left: 10px;
  position: relative;
  color: #011933;
}
.columnArea .columnGroup .column-button .column-button-b:nth-child(1) {
  margin-left: 0;
}
.columnArea .columnGroup .column-button .mom {
  border-radius: 4px;
  border: 1px solid #E6E8EB;
  padding-top: 8px;
  padding-bottom: 8px;
}
.columnArea .columnGroup .columnItem {
  display: flex;
  align-items: self-start;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #F5F6F7;
  padding-top: 12px;
  padding-bottom: 12px;
}
.columnArea .columnGroup .columnItem:last-child {
  border-bottom: none;
}
.columnArea .columnGroup .columnItem .name {
  line-height: 22px;
  width: 50%;
  text-align: left;
  font-size: 14px;
  color: #99A3AD !important;
}
.columnArea .columnGroup .columnItem .name.all{
  width: 100%;
}
.columnArea .columnGroup .columnItem .value {
  /* height: 62rpx; */
  line-height: 22px;
  width: 50%;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
}
.columnArea .columnGroup .columnItem .preimageList {
  margin-bottom: 0px;
  background-color: white;
}
.customization-clamp {
  display: -webkit-box !important;
}

::v-deep .hidden-header {
  display: none;
}
</style>
